import React from "react";
import * as C from "./styles";

interface Props {
  children: any;
  customStyle?: React.CSSProperties;
}

export default function FlexContainer({ children, customStyle }: Props) {
  return (
    <C.FlexContainer role="presentation" style={customStyle}>
      {children}
    </C.FlexContainer>
  );
}
